import { User } from '../../core/models';

export const userMock: User = {
  email: 'admin@admin.com',
  email_verified: false,
  first_name: 'Admin',
  id: 1,
  identity_verified: false,
  last_name: 'Admin',
  multi_factor_authentication_factor: '',
  phone_number: '+11234567890',
  phone_number_verified: true,
};
